import { render, staticRenderFns } from "./ArticleListIframe.vue?vue&type=template&id=313828c2&"
import script from "./ArticleListIframe.vue?vue&type=script&lang=ts&"
export * from "./ArticleListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports